import React from 'react';
import AutomatedVirtualToursContainer from '../components/AutomatedVirtualTours';
import CalendlyModal from '../components/CalendlyModal';
import Chat from '../components/Chat';
import CookieConsent from '../components/CookieConsent';
import EmbeddedTour from '../components/EmbeddedTour';
import Footer from '../components/Footer';
import GetStarted from '../components/GetStartedSc2lp';
import { MuktaVaani } from '../components/GlobalThemes';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import LearnMore from '../components/LearnMore';
import SEO from '../components/SEO';
import SpecialOffer from '../components/SpecialOffer';
import Steps from '../components/Steps';
import useLangRedirect from '../hooks/useLangRedirect';
import usePageContext from '../hooks/usePageContext';
import WebpProvider from '../providers/WebpProvider';

type Props = {
  promotionalPage?: 'gen' | 'remax';
};

const TemplateWrapper: React.FC<Props> = ({
  children,
  promotionalPage = 'remax',
}) => {
  useLangRedirect();
  const { title } = usePageContext();
  const [calendlyModalIsOpen, updateCalendlyModalIsOpen] = React.useState(
    false,
  );

  return (
    <WebpProvider>
      <MuktaVaani />
      <SEO title={title} />
      <Header
        updateCalendlyModalIsOpen={updateCalendlyModalIsOpen}
        calendlyModalIsOpen={calendlyModalIsOpen}
        promotionalPage={promotionalPage}
      />
      {children}
      <Footer promotionalPage={promotionalPage} />
      <CalendlyModal
        updateCalendlyModalIsOpen={updateCalendlyModalIsOpen}
        calendlyModalIsOpen={calendlyModalIsOpen}
      />
      <CookieConsent />
      <Chat />
    </WebpProvider>
  );
};

const GenSc2RemaxPage = () => {
  return (
    <TemplateWrapper promotionalPage="remax">
      <HeroSlider promotionalPage="remax" />
      <LearnMore promotionalPage="remax" />
      <EmbeddedTour />
      <Steps promotionalPage="remax" />
      <GetStarted promotionalPage="remax" />
      <AutomatedVirtualToursContainer promotionalPage="remax" />
      <SpecialOffer isPromotionalPage={true} promotionalPage="remax" />
    </TemplateWrapper>
  );
};

export default GenSc2RemaxPage;
